<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="cash-report-main-sidebar" position="left" lockedOpen="gt-md">
        <cash-report-main-sidebar></cash-report-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Number' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.number}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Start day cash' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.startDayCash}}
                                <span *ngIf="row.startDayComments" style="color: red;">
                                    <br/>
                                    {{row.startDayComments}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Current cash' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.cash}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'End day cash' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.endDayCash}}
                                <span *ngIf="row.endDayComments" style="color: red;">
                                    <br/>
                                    {{row.endDayComments}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Date' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.createdAt|date: 'd.MM.y': 'UTC': locale}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="true" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a routerLink="/cash-reports/show/{{row.id}}">{{'Details'|translate}}</a>&nbsp;
                                <a (click)="download(row)">{{'Download'|translate}}</a>&nbsp;
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
